import state from './moduleModuleManagementState.js'
import mutations from './moduleModuleManagementMutations.js'
import actions from './moduleModuleManagementActions.js'
import getters from './moduleModuleManagementGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}

